import { ChangeEvent, FC, useCallback } from 'react';
import S from './SwitchButton.module.scss';
import { Text } from 'src/redesign/components/Text';

type SwitchButtonProps = {
  items: [string, string];
  onChange: (item: string) => void;
  className?: string;
  value?: string;
};

export const SwitchButton: FC<SwitchButtonProps> = (props) => {
  const handleOnClick = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        props.onChange(props.items[1]);
        return;
      }
      props.onChange(props.items[0]);
    },
    [props],
  );

  // Determine if checkbox should be checked based on value prop
  const isChecked = props.value === props.items[1];

  return (
    <div>
      <input
        onChange={handleOnClick}
        type="checkbox"
        id="toggle"
        className={S.toggleCheckbox}
        checked={isChecked}
      />
      <label htmlFor="toggle" className={S.toggleContainer}>
        {props.items.map((item) => (
          <Text key={item} variation="body">
            {item}
          </Text>
        ))}
      </label>
    </div>
  );
};
